import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  //MeasureUnits
  getCounties({ commit }, payload) {
    return api.fetch(
      endpoints.ADDRESS_COUNTIES,
      payload,
      commit,
      (response) => {}
    );
  },
  getLocalities({ commit }, payload) {
    return api.fetch(
      endpoints.ADDRESS_LOCALITIES,
      payload,
      commit,
      (response) => {}
    );
  },
  getCountries({ commit }, payload) {
    return api.fetch(
      endpoints.ADDRESS_COUNTRIES,
      payload,
      commit,
      (response) => {}
    );
  },
};

export default actions;
